import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';

export default class SidekickOrganizationService {
  constructor(authCache) {
    this.authCache = authCache;
  }

  get(attrs, callback) {
    const cachedAuth = this.authCache.get();

    if (!cachedAuth) {
      return callback(null, { status: 401, statusText: statusText(401) });
    }

    callback(null, { status: 200, statusText: statusText(200), response: { id: cachedAuth.orgId } });
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/sidekick/api/organization': {
          GET: this.get,
        },
      },
      this
    );
  }
}
